<template>
    <div >
        <a  :href="getPoweredByURL" :target="getPoweredByURL !=='#' ? '_blank': ''" :disabled="!getPoweredByURL" class="powered-by">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20" fill="#404040">
                <g id="prefix__Richpanel_Logo_Mark_Color" transform="translate(-183 -183)" style="isolation:isolate">
                    <path id="prefix__Ellipse_1_copy_3" d="M201.455 203h-16.911a1.544 1.544 0 0 1-1.544-1.544v-16.912a1.544 1.544 0 0 1 1.544-1.544h16.911a1.544 1.544 0 0 1 1.545 1.544v16.911a1.544 1.544 0 0 1-1.545 1.545z" data-name="Ellipse 1 copy 3" style="fill-rule:evenodd;"/>
                    <path id="prefix__Ellipse_6_copy_3" d="M321.17 315.96a.618.618 0 0 1-1.2.2 1.126 1.126 0 1 0-1 1.642 1.117 1.117 0 0 0 .6-.172.619.619 0 0 1 .112-.079l.04-.033.005.011a.613.613 0 0 1 .5 1.119l.006.013a2.375 2.375 0 0 1-3.294-.793 4.572 4.572 0 0 0-2.556 3.592.755.755 0 0 1-.749.61.715.715 0 0 1-.719-.711 2.775 2.775 0 0 1 .079-.643 5.461 5.461 0 0 1 3.634-4.281 2.368 2.368 0 0 1 4.5-.724.6.6 0 0 1 .042.249zm1.837 10.8a.618.618 0 0 1 .432-1.139 1.126 1.126 0 1 0-.923-1.684 1.117 1.117 0 0 0-.149.6.618.618 0 0 1 .013.137q0 .026.009.051h-.012a.612.612 0 1 1-1.218-.127h-.015a2.375 2.375 0 0 1 2.334-2.456 4.572 4.572 0 0 0-1.832-4.01.755.755 0 0 1-.153-.954.715.715 0 0 1 .976-.267 2.782 2.782 0 0 1 .518.39 5.461 5.461 0 0 1 1.89 5.288 2.368 2.368 0 0 1-1.621 4.255.605.605 0 0 1-.249-.081zm-10.374-3.775a.618.618 0 0 1 .77.944 1.126 1.126 0 1 0 1.92.043 1.118 1.118 0 0 0-.446-.429.618.618 0 0 1-.125-.057l-.049-.018.007-.01a.618.618 0 0 1 .047-1.034.612.612 0 0 1 .673.042l.009-.012a2.375 2.375 0 0 1 .96 3.249 4.571 4.571 0 0 0 4.389.418.756.756 0 0 1 .9.344.715.715 0 0 1-.256.979 2.781 2.781 0 0 1-.6.254 5.461 5.461 0 0 1-5.524-1.007 2.368 2.368 0 0 1-2.875-3.531.6.6 0 0 1 .2-.172z" data-name="Ellipse 6 copy 3" transform="translate(-125.911 -128.185)" style="fill:#fff;fill-rule:evenodd"/>
                </g>
            </svg>
            <span class="powered-by-text">{{ poweredByText }}</span>
        </a>
    </div>
</template>

<script>
export default {
    props: {
        getPoweredByURL: String
    },

    computed: {
        poweredByText() {
            return ['minerseuropebv558'].includes(this.$root.configuration.tenantId) ? 'CRM by Richpanel' : this.$t('homeScreen.poweredBy')
        }
    }
}
</script>

<style lang="scss" scoped>
.powered-by {
    display: flex;
    align-items: center;
    padding: 5px 11px !important;
    &:hover {
        background: #f7f7f7;
        border-radius: 10px;
        svg {
                fill:#004e96;
            }
            .powered-by-text {
                color: #444444;
            }
        }
    .powered-by-text {
        font-weight: 400;
        font-size: 12px;
        color: #777777;
        padding-left: 8px;
        line-height: 0;
    }
}
</style>